@import 'db-ui-core.general';
@import 'notification';

:host {
  @extend body;
}
